import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Grid2,
  Paper,
  Typography,
} from "@mui/material";
import cx from "classnames";
import { displayDate, EntityTypes, howLongAgo } from "../../common/Constants";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PersonIcon from "@mui/icons-material/Person";
import { ApplicantCard } from "../../common/AddressView";
import { Margin } from "@mui/icons-material";

/*
leftText:
date:
subText
status
note/error
*/

const Card11 = ({ title, t1, d1, t2, t3, t4, status, note }) => {
  return (
    <React.Fragment>
      <Grid2 container>
        <Grid2 size={6}>
          <Typography variant="caption">Voucher</Typography>
          <Typography sx={{ fontSize: 14 }}>
            {title}
          </Typography>
          <Typography variant="caption">
            {displayDate(d1)}
          </Typography><br />
        </Grid2>
        <Grid2 size={6}>
          <Typography variant="caption">Applicant</Typography>
          <Typography sx={{ fontSize: 14 }}>{t2}</Typography>
          <Typography sx={{ fontSize: 13, fontWeight: 'bold' }} className={cx("voucher-status", status)}>{status}</Typography>
        </Grid2>
        <Grid2 size={12}
          sx={{
            pt: 2,
          }}
        >
          <Typography variant="caption">{t4}</Typography>
          <Typography sx={{
            fontSize: 18,
            fontWeight: 'bold',
          }}> {t1}</Typography>
        </Grid2>

      </Grid2>
      <Grid2 container spacing={3} >
        <Grid2
          item
          xs={12}
          style={{ color: status === "rejected" ? "red" : "inherit" }}
        >
          {note && <Typography sx={{ fontSize: 13, color: '#666' }}>{note}</Typography>}
        </Grid2>
      </Grid2>
    </React.Fragment>
  );
};

const Card1 = ({ title, t1, d1, t2, t3, t4, status, note }) => {
  return (
    <React.Fragment>
      <Grid2 container>
        <Grid2 size={3}>
        <Typography variant="caption">Voucher</Typography>
          <Typography sx={{fontSize: 14}}>
            {title}
          </Typography>
        </Grid2>
        <Grid2 size={4}>
          <Typography variant="caption">Applicant</Typography>
          <Typography sx={{fontSize: 14}}>{t2}</Typography>
         
        </Grid2>
        <Grid2 size={5}>
          <Typography variant="caption">
            {displayDate(d1)}
           
          </Typography>
          <Typography sx={{fontSize: 13, fontWeight: 'bold'}} className={cx("voucher-status", status)}>{status}</Typography>
        </Grid2>
        <Grid2 size={12} 
        sx={{
          pt: 2,
        }}
        >
          <Typography variant="caption">{t4}</Typography>
          <Typography sx={{fontSize: 20,
          fontWeight: 'bold',}}> {t1}</Typography>
        </Grid2>
        
      </Grid2>
      <Grid2 container spacing={3} >
        <Grid2
          item
          xs={12}
          style={{ color: status === "rejected" ? "red" : "inherit" }}
        >
          {note && <Typography sx={{fontSize:13, color:'#666'}}>{note}</Typography>}
        </Grid2>
      </Grid2>
    </React.Fragment>
  );
};

//?? Unify: name, full_name, first_name, last_name
const AddressCard = ({
  id,
  name,
  first_name,
  last_name,
  address1,
  city,
  state,
  zip,
  phone,
  phone_extension,
}) => {
  name = first_name ? `${first_name} ${last_name}` : name;
  return (
    <Grid2 container>
      <Grid2 size={12}>
        <Typography variant="subtitle2">{name}</Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography variant="subtitle2" color="textSecondary">
          {address1}
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography variant="subtitle2" color="textSecondary">
          {city}, {state} {zip}
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography variant="subtitle2" color="textSecondary">
          {phone}
          {phone_extension ? " Ext. " + phone_extension : ""}
        </Typography>
      </Grid2>
    </Grid2>
  );
};
// include first registration date to agency card
const AgencyCard = ({
  id,
  name,
  first_name,
  last_name,
  address1,
  city,
  state,
  zip,
  phone,
  phone_extension,
  createdOn,
  required_invoice,
}) => {
  name = first_name ? `${first_name} ${last_name}` : name;
  return (
    <Grid2 container>
      <Grid2 size={8}>
        <Typography variant="button" color="textSecondary">
          {" "}
          Agency ID: {id}{" "}
        </Typography>
      </Grid2>
      <Grid2 size={4}>
        <Typography variant="subtitle2" color="textSecondary">
          {displayDate(createdOn)}
        </Typography>
      </Grid2>
      <Grid2 size={9}>
        <Grid2 size={12}>
          <Typography variant="subtitle2">{name}</Typography>
        </Grid2>
        {/* <Grid2 size={12}>
                  <Typography variant='subtitle2'>{  displayDate(createdOn)}</Typography>
              </Grid2> */}
        <Grid2 size={12}>
          <Typography variant="subtitle2" color="textSecondary">
            {address1}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Typography variant="subtitle2" color="textSecondary">
            {city}, {state} {zip}
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Typography variant="subtitle2" color="textSecondary">
            {phone}
            {phone_extension ? " Ext. " + phone_extension : ""}
          </Typography>
        </Grid2>
      </Grid2>
      <Grid2 size={3} alignSelf="flex-end">
        {required_invoice && (
          <Typography variant="subtitle2" color="textSecondary">
            Invoice required
          </Typography>
        )}
        {!required_invoice && (
          <Typography variant="subtitle2" color="textSecondary">
            Pay as you go
          </Typography>
        )}
      </Grid2>
    </Grid2>
  );
};

const UserCard = ({
  tt,
  name,
  first_name,
  last_name,
  email,
  phone,
  phone_extension,
  is_admin,
  createdOn,
}) => {
  name = first_name ? `${first_name} ${last_name}` : name;
  console.log(tt);
  return (
    <Grid2 container>
      <Grid2 size={10}>
        <Typography variant="subtitle2">{name}</Typography>
      </Grid2>
      <Grid2 size={2}>
        {is_admin && <SupervisorAccountIcon />}
        {!is_admin && <PersonIcon />}
      </Grid2>
      <Grid2 size={9}>
        <Typography variant="subtitle2" color="textSecondary">
          {email}
        </Typography>
      </Grid2>
      {/* march 2023 enhancement include user first created on */}
      <Grid2 size={3}>
        <Typography variant="caption" color="textSecondary">
          {displayDate(createdOn)}
        </Typography>
      </Grid2>
      <Grid2 size={9}>
        <Typography variant="subtitle2" color="textSecondary">
          {phone}
          {phone_extension ? " Ext. " + phone_extension : ""}
        </Typography>
      </Grid2>
      <Grid2 size={3}>
        {tt === EntityTypes.pendingUser && (
          <Typography variant="subtitle2" color="error">
            {howLongAgo(createdOn)}
          </Typography>
        )}
      </Grid2>
    </Grid2>
  );
};

const CognitoCard = ({
  name,
  email,
  phone_number,
  email_verified,
  user_status,
  updatedOn,
}) => {
  return (
    <Grid2 container>
      <Grid2 size={8}>
        <Typography variant="subtitle2">{name}</Typography>
      </Grid2>
      <Grid2 size={4}>{user_status}</Grid2>
      <Grid2 size={12}>
        <Typography variant="subtitle2" color="textSecondary">
          {email}
        </Typography>
      </Grid2>
      <Grid2 size={12}>
        <Typography variant="subtitle2" color="textSecondary">
          {phone_number}
        </Typography>
      </Grid2>
    </Grid2>
  );
};

const TextCard = ({ title }) => {
  return (
    <Grid2 container>
      <Grid2 size={12}>
        <Typography variant="subtitle2">{title}</Typography>
      </Grid2>
    </Grid2>
  );
};

const EmptyItem = { id: 0 };

const CardGrid = ({
  itemsAsync,
  itemsFn = (data) => data,
  itemfn,
  onSelect,
  itemTypeFn,
  gridHeader,
  selectedItemFn,
  emptyCardText,
}) => {
  const [displayCount, setDisplayCount] = useState(100);

  const [lastClickedItem, setLastClickedItem] = useState();

  useEffect(() => {
    if (itemsAsync.data) {
      let total = itemsAsync.data.length;
      setDisplayCount(total > 100 ? 100 : total);
    } else {
      setDisplayCount(100);
    }

    // Check if any item should be selected by default
    if (selectedItemFn) {
      // console.log("selectedItemFn")
      // console.log(itemsAsync.data)
      setLastClickedItem(itemsAsync.data.find((item) => selectedItemFn(item)));
    }
  }, [itemsAsync.data]);

  //  console.log(displayCount)

  return (
    <React.Fragment>
      {itemsAsync.loading && <CircularProgress />}
      {itemsAsync.error && <div>{itemsAsync.error.message}</div>}
      {itemsAsync.data && (
        <Grid2
          container
          spacing={3}
          justifyContent={"space-evenly"}
          style={{ padding: "48px", margin: "0 auto"}}
        >
          {gridHeader && gridHeader(itemsAsync.data)}
          {itemsFn(itemsAsync.data)
            .slice(0, displayCount)
            .map((item, index) => (
              <Grid2 key={index}>
                <Paper
                  onClick={() => {
                    setLastClickedItem(item);
                    onSelect && onSelect(item);
                  }}
                  className={cx("voucher-card", {
                    clickable: true,
                    selected: lastClickedItem === item,
                  })}
                >
                  {itemTypeFn(item) === EntityTypes.voucher && (
                    <Card11 {...itemfn(item)} />
                  )}
                  {(itemTypeFn(item) === EntityTypes.user ||
                    itemTypeFn(item) === EntityTypes.pendingUser) && (
                    <UserCard tt={itemTypeFn(item)} {...itemfn(item)} />
                  )}
                  {itemTypeFn(item) === EntityTypes.applicant && (
                    <ApplicantCard {...itemfn(item)} />
                  )}
                  {itemTypeFn(item) === EntityTypes.agency && (
                    <AgencyCard {...itemfn(item)} />
                  )}
                  {itemTypeFn(item) === EntityTypes.dispenser && (
                    <AddressCard {...itemfn(item)} />
                  )}
                  {itemTypeFn(item) === EntityTypes.cognito && (
                    <CognitoCard {...itemfn(item)} />
                  )}
                </Paper>
              </Grid2>
            ))}
          {emptyCardText && (
            <Grid2>
              <Paper
                onClick={() => {
                  setLastClickedItem(EmptyItem);
                  onSelect && onSelect(EmptyItem);
                }}
                className={cx("voucher-card", {
                  clickable: true,
                  selected: lastClickedItem === EmptyItem,
                })}
              >
                <TextCard title={emptyCardText} />
              </Paper>
            </Grid2>
          )}
          {itemsAsync.data.length > displayCount && (
            <Button
              onClick={() =>
                setDisplayCount((displayCount) => displayCount + 100)
              }
              color="primary"
            >
              Show more
            </Button>
          )}
        </Grid2>
      )}
    </React.Fragment>
  );
};

export default CardGrid;

export { AddressCard, TextCard };
